import Page from "~/pages/Page";
import Autocomplete, {Config} from "bootstrap5-autocomplete";
import { getApi, maskOn, maskOff, getImpersonator } from "~/auth";
import "~/globals";


function ShowCustomUserData(newuser: any) {
    let html = `
        <div class='mask-user-details'>
            <h4>Stai impersonando:</h4>

            <ul class="list-unstyled lh-lg">
                <li class="d-flex justify-content-between gap-3">
                    <div class="fw-bold">Nome:
                    </div>
                    <div>${newuser.Nome}</div>
                </li>
                <li class="d-flex justify-content-between gap-3">
                    <div class="fw-bold">Cognome:
                    </div>
                    <div>${newuser.Cognome}</div>
                </li>
                <li class="d-flex justify-content-between gap-3">
                    <div class="fw-bold">Email:
                    </div>
                    <div>${newuser.Email}</div>
                </li>
                <li class="d-flex justify-content-between gap-3">
                    <div class="fw-bold">Id Anagrafica:
                    </div>
                    <div>${newuser.Id}</div>
                </li>
                <li class="d-flex justify-content-between gap-3">
                    <div class="fw-bold whiteSpace-nowrap">User Id:
                    </div>
                    <div>${newuser.IdAspNet}</div>
                </li>
                <li class="d-flex justify-content-between gap-3 align-items-center">
                    <div class="fw-bold whiteSpace-nowrap">Ruoli:</div>
                    <div class="d-flex gap-2 flex-wrap justify-content-end">
                        ${formatRuoli(newuser.Ruoli)}
                    </div>
                </li>
            </ul>
        </div>
    `;

    $("#boxuser").html(html);
}


// ✅ Funzione helper per formattare i ruoli
function formatRuoli(ruoli: string[] | string | null | undefined): string {
    // Se è già una stringa, ritornala così com'è
    if (typeof ruoli === 'string') {
        return ruoli.split(',').map(r =>
            `<span class="badge bg-secondary">${r.trim()}</span>`
        ).join('');
    }

    // Se è un array
    if (Array.isArray(ruoli) && ruoli.length > 0) {
        return ruoli.map((ruolo: string) =>
            `<span class="badge bg-secondary">${ruolo}</span>`
        ).join('');
    }

    // Nessun ruolo
    return '<span class="text-muted fst-italic">Nessun ruolo</span>';
}

class Impersona extends Page {
    constructor() {
        super("impersona", "Impersonazione Utente");
    }
    async pageStart(): Promise<void> {
        
        let selectedItem : any = null;
        // let optionsOld = {
        //    
        //     adjustWidth: false,
        //     url: function (searchText: string) {
        //         let _url = BaseUrlWebApi + "Anagrafica/GetUsers?search=" + searchText
        //         return _url;
        //     },
        //     getValue: function (element: any) {
        //         if ( $("#opt1").prop("checked") == true )
        //             return $(element)[0].Cognome;
        //         else
        //             return $(element)[0].Id.toString();
        //     },
        //     placeholder: "min. 3 caratteri",
        //     minCharNumber: 3,
        //     list: {
        //         onLoadEvent: function () {
        //             Common.UI.HideWait();
        //             Common.AJAX.UnBindWaiting();
        //             $("#btnImpersona").attr("disabled","true");
        //             $("#txtJsonSelUser").val("");
        //         },
        //         onSelectItemEvent: function () {
        //
        //         },
        //         onClickEvent: function () {
        //
        //         },
        //         onChooseEvent: function () {
        //             Common.AJAX.BindWaiting();
        //             let item = $("#txtSelUser").getSelectedItemData();
        //             $("#txtSelUser").val(item.Cognome + " " + item.Nome + " (" + item.Id + ")");
        //             $("#txtJsonSelUser").val(JSON.stringify(item));
        //             $("#btnImpersona").removeAttr("disabled");
        //         },
        //         onHideListEvent: function () {
        //
        //         },
        //         match: {
        //             enabled: true
        //         },
        //         maxNumberOfElements: 60
        //     },
        //     template: {
        //         type: "custom",
        //         method: function (value, item) {
        //             return item.Cognome + " " + item.Nome + " (" + item.Id + ")";
        //         }
        //     },
        //     theme: "square"
        // };
        const auth = getApi();
        let tokens = await auth.getUserTokens(true);
        
        let options: Partial<Config> = {
            suggestionsThreshold: 1,
            
            autoselectFirst: true,
            updateOnSelect: false,
            ignoreEnter: false,
            tabSelect: true,
            highlightTyped: true,
            highlightClass: "text-primary",
            labelField: "Nominativo",
            valueField: "Id",
            searchFields: ["Cognome","Id"],
            queryParam: "search",
            onRenderItem : function (item, currentValue) {
                return `${item.Id} - ${item.Cognome} ${item.Nome} (${item.Email})`;
            },
            server: window.BaseUrlWebApi + "Anagrafica/GetUsers",
            fetchOptions: {
                credentials: "include",
                ...(tokens.accessToken && {
                    headers: new Headers({
                        'Authorization': 'Bearer ' + tokens.accessToken 
                    })
                })
            },
            liveServer:true,
            debounceTime: 300,
            onSelectItem: (item, query) => {
                $("#btnImpersona").prop("disabled", false);
                selectedItem = item;
                console.log('====>', item);
                $("#txtJsonSelUser").val(JSON.stringify(item));
            },
            onServerResponse: async (response, query) => {
                let data : any = await response.json();
                data = data.map((item: any) => {
                    item.Nominativo = `${item.Cognome} ${item.Nome} (${item.Email})`;
                    return item;
                });
                
                return data;
            }
            
        }

        Autocomplete.init("#txtCognome", options);
        let ac = Autocomplete.getInstance($("#txtCognome")[0] as HTMLInputElement) as Autocomplete;
      
        const impersonator = await getImpersonator();
        
        $("#txtCognome").keypress(function (e) {
            $("#btnImpersona").prop("disabled", true);
            $("#txtJsonSelUser").val("");
        });

        $("#btnImpersona").click(async function (e) {
            e.preventDefault();
            let newuser = JSON.parse($("#txtJsonSelUser").val() as any);
            if (newuser && newuser.IdAspNet) {
                try {
                    await maskOn(newuser.IdAspNet);
                    $("#frmImpersona").submit();
                } catch (err) {
                    console.log(err);
                    //TODO: annullare il mask lato server
                }            
            }
    
            //console.log("==== Mask On ====", newuser);
            
        });

        if ( $("#txtMaskOn").val() == "true" )
        {
            let newuser = JSON.parse($("#txtJsonSelUser").val() as string);
            //segno il mask
            
            ShowCustomUserData(newuser);
            $("#user-selector").toggleClass("d-none", true);
        }

         if (impersonator && $("#txtMaskOff").val() == "true") {
            await maskOff();
             window.location.reload();
         }
        return Promise.resolve(undefined);
    }


}


export default Impersona;